import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import RoleInformation  from '../../component/Role/RoleInformation';
import InternalRolePermissions from '../../component/Role/InternalRolePermissions';
import { Alert } from '../../component/Alert/Alert';
import Has from '../../component/Permission/Has';
import { Link, useLocation } from 'react-router-dom';
import { ROLE_INTERNAL_U_USER_ADMIN } from '../../config/PermissionTypes';
import { saveInternalRole } from '../../service/UserService';
import './InternalRoles.css'

export default function EditInternalRole(props) {

    const location = useLocation();
    const { editRole } = location.state;
    const [role, setRole] = useState(editRole);
    const [errors, setErrors] = useState({});
    const [savePending, setSavePending] = useState(false);
    const [banner, setBanner] = useState({
        show: false,
        type: "success",
        message: ""
    });

    const isSaveDisabled = () => {
        const errorsExist = !_.isEmpty(errors);
        return !role.roleName || errorsExist || savePending;
    }

    function handleRoleUpdate(field, value) {
        let updatedRole = {...role};
        updatedRole[field] = value
        setRole(updatedRole);
    }

    const handleSaveRole = async () => {
        setSavePending(true);
        saveInternalRole(role, callbackHandler, callbackHandlerError);
    }

    function callbackHandlerError(response) {
        let message = "Something went wrong. Please try again later."
        if (response?.status === 400) {
            message = response.data;
        }
        showBanner("error", message);
        setSavePending(false);
    }

    function callbackHandler(response) {
        showBanner("success", <>Your changes were sucessfully updated! <Link to="/system/internalRoles">Back to Internal Roles page</Link></>);
        setSavePending(false);
    }

    const showBanner = (type, message) => {
        setBanner({
            show: true,
            type: type,
            message: message
        })
    }

    return (
        <><Has isPageLevel={true} permission={ROLE_INTERNAL_U_USER_ADMIN}>
            <div className="container-fluid edit-internal-role-page" data-testid="edit-internal-role-page">
                <div className="cb-row page-title-area">
                    <div className="cb-col-xs-8 cb-col-lg-8 page-title">
                        <h1 data-testid="add-user-page-header-title">Edit Internal Role</h1>
                    </div>
                </div>

                {banner.show && 
                    <Alert type={`${banner.type}`} handleOnClose={() =>  setBanner({ show: false, message: ""})} dataTestId='edit-role-notification'>
                        <div style={{ fontWeight: '500' }}>{banner.message}</div>
                    </Alert>}

                    <div className="role-info-container" data-testid="role-info-fields">
                    <div className="sectionTitle">Role Information</div>
                    <RoleInformation 
                        readOnly={false}
                        roleName={role.roleName}
                        description={role.description}
                        errors={errors}
                        setErrors={setErrors}
                        handleFieldUpdate={handleRoleUpdate}
                    />
                </div>

                <div className="permissions-container" data-testid="role-permission-options">
                    <div className="sectionTitle">Permissions</div>
                    <InternalRolePermissions 
                        permissions={role.permissions} 
                        handlePermissionUpdate={handleRoleUpdate} />
                </div>

                <div className="role-buttons" data-testid="edit-role-buttons">
                    <Link to="/system/internalRoles">
                        <button
                            type="button"
                            className="cb-btn cb-btn-outline-secondary"
                            data-testid="create-role-cancel"
                            disabled={false}
                            onClick={() => null}>
                            Cancel
                        </button>
                    </Link>
                    <button 
                        className="cb-btn cb-btn-primary" 
                        data-testid="create-role-submit" 
                        disabled={isSaveDisabled()}
                        onClick={() => handleSaveRole()}>
                        Update Role
                    </button>
                </div>

            </div>
        </Has></>
    );
}